import axios from 'axios';
import { clearAuthToken, getAuthToken } from './authToken';

const url = process.env.REACT_APP_API_URL;
const adminRequest = axios.create({
  baseURL: `${url}/admin`,
  withCredentials: true,
  transformResponse: [(response) => {
    if (response) {
      return JSON.parse(response).data;
    }
    return null;
  }],
});

adminRequest.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

adminRequest.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearAuthToken();
    }
    return Promise.reject(error);
  },
);

export default adminRequest;
